import { Button } from '@chakra-ui/button';
import { Stack, Text } from '@chakra-ui/layout';
import { Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/menu';
import { Portal } from '@chakra-ui/portal';
import { Icon } from '@chakra-ui/react';
import { Tag } from '@chakra-ui/tag';
import TokenIcon from 'components/shared/TokenIcon';
import { BiChevronDown } from 'react-icons/bi';
import { GiPirateFlag } from 'react-icons/gi';
import { ERC20Token } from 'types';
import { truncate } from 'utils/address';

type Props = {
  selectedAsset: ERC20Token | null;
  assets: ERC20Token[];
  setSelectedAsset: (asset: ERC20Token) => void;
  tokenBlacklist: string[];
};

const AssetSelector: React.FC<Props> = ({
  selectedAsset,
  assets,
  setSelectedAsset,
  tokenBlacklist
}) => {
  return (
    <Menu placement='bottom-end' autoSelect={false}>
      <MenuButton
        bg='whiteAlpha.200'
        variant='ghost'
        size='sm'
        as={Button}
        rightIcon={<BiChevronDown />}
        _hover={{
          bg: 'whiteAlpha.300'
        }}
      >
        <Stack direction='row' alignItems='center'>
          <TokenIcon asset={selectedAsset} />
          <Text>{truncate(selectedAsset?.symbol)}</Text>
        </Stack>
      </MenuButton>
      <Portal>
        <MenuList maxHeight='240px' overflowY='auto' zIndex={4}>
          {assets.map((asset) => (
            <MenuItem
              key={asset.address}
              bg={asset.address === selectedAsset?.address ? 'gray.600' : ''}
              onClick={() => setSelectedAsset(asset)}
            >
              <TokenIcon asset={asset} mr={2} />
              {asset.symbol}
              {tokenBlacklist.some((token) => {
                return token.toLowerCase() === asset.address.toLowerCase();
              }) && (
                <Tag colorScheme='red' ml={2}>
                  <Text display={['none', null, 'unset']}>Phish/Scam</Text>
                  <Icon ml={[0, null, 2]} as={GiPirateFlag} />
                </Tag>
              )}
            </MenuItem>
          ))}
        </MenuList>
      </Portal>
    </Menu>
  );
};

export default AssetSelector;
